import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginAdmin } from '../services/adminService';

function AdminLogin() {
  const navigate = useNavigate();
  const [values, setValues] = useState({ username: '', password: '' });
  const [status, setStatus] = useState({ loading: false, error: '' });

  const updateValue = (event) => {
    const { name, value } = event.target;
    setValues((current) => ({ ...current, [name]: value }));
    setStatus({ loading: false, error: '' });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus({ loading: true, error: '' });

    try {
      await loginAdmin(values);
      navigate('/admin/dashboard', { replace: true });
    } catch (error) {
      setStatus({ loading: false, error: 'Invalid admin credentials.' });
    }
  };

  return (
    <div className="admin-shell admin-shell--center">
      <form className="admin-auth-card" onSubmit={handleSubmit}>
        <p className="eyebrow">FactorStreet Admin</p>
        <h1>Login</h1>
        <label>
          <span>Username</span>
          <input
            autoComplete="username"
            name="username"
            onChange={updateValue}
            required
            type="text"
            value={values.username}
          />
        </label>
        <label>
          <span>Password</span>
          <input
            autoComplete="current-password"
            name="password"
            onChange={updateValue}
            required
            type="password"
            value={values.password}
          />
        </label>
        <button className="btn btn--primary" disabled={status.loading} type="submit">
          {status.loading ? 'Signing in...' : 'Login'}
        </button>
        {status.error ? <p className="form-alert form-alert--error">{status.error}</p> : null}
      </form>
    </div>
  );
}

export default AdminLogin;
